import { Injectable } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IntrensicOfficerBaseResponse } from '@intrensic/shared/officer-details';
import { Observable } from 'rxjs';
import { BaseApiService } from '@shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class OfficerRespondToOptionsService {
  constructor(private baseApiService: BaseApiService) {}

  getOfficerRespondToOptions(officerUid: string): Observable<IntrensicOfficerBaseResponse[]> {
    return this.baseApiService.get<IntrensicOfficerBaseResponse[]>(`api/users?userUID=${officerUid}`);
  }
}
